import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Modal } from "antd";
import { Alert } from "components/elements";
import alert from "components/elements/Alert";
import dayjs from "dayjs";
import { setPayrollPeriod, setPeriodOptions } from "features/payment/slices/PaymentSlices";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { generateRandomString } from "utils/helper";
import PayrollPeriodCalculateDetailsModal from "../components/PayrollModal/PayrollPeriodDetailsModal";
import * as services from "../services/payrollPeriodApi";
import {
    setDeductionForSpecialPeriod,
    setEmploymentTypeOption,
    setIncomeForSpecialPeriod,
    setIsLoading,
    setIsLoadingPage,
    setPayrollPeriodCalculateDetails,
    setPayrollPeriodList,
    setPayrollPeriodListPage,
    setPayrollPerMonth,
    setSpecialPeriodDropdown
} from "../slices/payrollSlice";

import {
    setIsLoading as isLoadingPayment
} from "../../payment/slices/PaymentSlices";
import { getPeriodOptions } from "features/Report/services/reportApi";

function usePayrollPeriod() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [isModalOpen, setModalOpen] = useState(false);
    const [isModalOpenPerMonth, setModalOpenPerMonth] = useState(false);
    const [isModalDetailsOpen, setIsModalDetailsOpen] = useState(false);
    const [year, setYear] = useState(dayjs().year());
    const [month, setMonth] = useState(null);
    const [statusFlag, setStatusFlag] = useState(null);
    const isLoading = useSelector((state) => state.payroll.isLoading);
    const payrollPeriodList = useSelector((state) => state.payroll.payrollPeriodList);
    const payrollPeriodListPage = useSelector((state) => state.payroll.payrollPeriodListPage);
    const incomeForSpecialPeriod = useSelector((state) => state.payroll.incomeForSpecialPeriod);
    const deductionForSpecialPeriod = useSelector((state) => state.payroll.deductionForSpecialPeriod);
    const payrollPerMonth = useSelector((state) => state.payroll.payrollPerMonth);
    const { employmentTypeOption, specialPeriodOption, payrollPeriodCalculateDetails } = useSelector((state) => state.payroll);
    const { periodOptions } = useSelector((state) => state.payment);
    const { currentCompany, currentEmployee, } = useSelector((state) => state.company);
    const [visible, setVisible] = useState(false);
    const [pagination, setPagination] = useState({ page: 0, size: 10, pageSize: 10 });
    const [pagination2, setPagination2] = useState({ page: 0, size: 10, pageSize: 10 });
    const [selectedPayrollPeriodId, setSelectedPayrollPeriodId] = useState();
    const [isSpecialPeriodModalOpen, setIsSpecialPeriodModalOpen] = useState(false);

    // console.log("payrollPeriodList", payrollPeriodList);


    const modifiedIncomeForSpecialPeriod = useMemo(() => {
        const modifiedOptions = incomeForSpecialPeriod.map((opt) => ({
            label: i18n.language === "en" ? opt.nameEn : opt.name,
            value: opt.id,
        }));
        return modifiedOptions;
    }, [i18n.language, incomeForSpecialPeriod]);

    const modifiedDeductionForSpecialPeriod = useMemo(() => {
        const modifiedOptions = deductionForSpecialPeriod.map((opt) => ({
            label: i18n.language === "en" ? opt.nameEn : opt.name,
            value: opt.id,
        }));
        return modifiedOptions;
    }, [deductionForSpecialPeriod, i18n.language]);

    const onCancel = useCallback(() => {
        setModalOpen(false);
        setModalOpenPerMonth(false);
    }, [])

    const onCancelPerMonth = useCallback(() => {
        setModalOpenPerMonth(false);
    }, [])

    const handleOk = () => {
        setModalOpen(false)
    }

    const handleVisible = useCallback((value) => {
        setVisible(value)
    }, [])

    const getEmploymentType = useCallback(
        async (values) => {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                };
                const response = await services.employmentTypeOption(values);
                dispatch(setEmploymentTypeOption(response.data?.employmentTypeSetupList));

            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch]
    );

    function employmentTypeDropdown() {
        return employmentTypeOption?.map((o, index) => {
            return { label: o.employmentTypeName, value: o.id }
        })
    }


    const getPayrollPeriod = useCallback(async (payrollId) => {
        try {
            if (payrollId) {
                dispatch(setIsLoading(true))
                const response = await services.getPayrollPeriod({
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    actionId: currentEmployee,
                    txnPayrollPeriodId: payrollId,
                })
                dispatch(setPayrollPeriod(response?.data))
            }
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])

    const updatePeriodOptions = useCallback(
        async (targetMonth, employmentTypeId) => {
            try {
                dispatch(setIsLoading(true));
                // if (targetMonth) {
                console.log("currentCompany", currentCompany);

                const monthResponse = await getPeriodOptions({ companyId: currentCompany, year: dayjs().year(), month: targetMonth, employmentTypeId: [employmentTypeId] });
                dispatch(setPeriodOptions(monthResponse?.data));
                // }
            } catch (error) {
                console.error("Error updating dropdown options:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch]
    );


    const createPayment = useCallback(async (id) => {
        try {
            const baseRequest = {
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: id,
            }
            dispatch(setIsLoading(true))
            const response = await services.editPayment(baseRequest)
            if (response?.data?.content?.details?.[0]?.value) {
                Modal.error({
                    content: <span>{response?.data?.content?.details?.[0]?.value}</span>,
                    okText: t('message.ok'),
                });
                return false;
            }
            return true;
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
            return false;
        } finally {
            dispatch(setIsLoading(false))
        }
    }, [currentCompany, currentEmployee])




    const createPaymentByEmployeeIds = useCallback(async (id, employeeIds) => {
        try {
            const baseRequest = {
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
                txnPayrollPeriodId: id,
                employeeIds
            }
            dispatch(isLoadingPayment(true))
            await services.createPaymentByEmployeeIds(baseRequest)
        } catch (error) {
            Alert({ type: 'error', resultObject: error })
        } finally {
            dispatch(isLoadingPayment(false))
        }
    }, [currentCompany, currentEmployee])

    const onPayrollClick = useCallback(async (id) => {
        if (id) {
            const success = await createPayment(id);
            if (success) {
                navigate(`/payroll/payment/${id}`);
                getPayrollPeriod(id);
            }
        }
    }, [currentCompany, currentEmployee, navigate, createPayment, getPayrollPeriod]);


    const getSPecialPeriodDropdown = useCallback(
        async ({ year } = {}) => {
            try {
                dispatch(setIsLoading(true));
                const values = {
                    year: year,
                    companyId: currentCompany
                };
                const response = await services.specialPeriodOption(values);
                // console.log("response", response);
                dispatch(setSpecialPeriodDropdown(response.data));
            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, dispatch]
    )

    const getIncomeForSpecialPeriod = useCallback(async () => {
        try {
            dispatch(setIsLoading(true));
            const values = {
                requestId: generateRandomString(),
                companyId: currentCompany,
                actionId: currentEmployee
            };
            const response = await services.getIncomeForSpecialPeriod(values);
            dispatch(setIncomeForSpecialPeriod(response.data));
        } catch (error) {
            alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    },
        [currentCompany, currentEmployee, dispatch]
    )

    const getDeductionForSpecialPeriod = useCallback(async () => {
        try {
            dispatch(setIsLoading(true));
            const values = {
                requestId: generateRandomString(),
                companyId: currentCompany,
                actionId: currentEmployee
            };
            const response = await services.getDeductionForSpecialPeriod(values);
            dispatch(setDeductionForSpecialPeriod(response.data));
        } catch (error) {
            alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    },
        [currentCompany, currentEmployee, dispatch]
    )

    function specialPeriodDropdown() {
        return Array.isArray(specialPeriodOption) ? specialPeriodOption.map((o, index) => {
            return { ...o, label: o.name, value: o.index };
        }) : [];
    }

    const getPayrollPeriodList = useCallback(
        async ({ changeYear } = {}) => {
            try {
                // setYear(year);

                dispatch(setIsLoadingPage(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    year: changeYear?.year?.() || year,
                    visible: visible,
                };
                const response = await services.getPayrollPeriodList(values);
                dispatch(setPayrollPeriodList(response?.data?.content || []));
            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoadingPage(false));
            }
        },
        [currentCompany, year, visible]
    );
    const getPayrollPeriodListPage = useCallback(
        async ({ changeYear, pagination } = {}) => {

            // console.log("changeYear changeYear", changeYear, pagination);

            try {
                dispatch(setIsLoadingPage(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    month: month,
                    year: changeYear?.year?.() || year,
                    statusFlag: statusFlag,
                    visible: visible,
                    ...pagination
                };
                const response = await services.getPayrollPeriodListPage(values);
                dispatch(setPayrollPeriodListPage(response?.data?.page?.content || []));
                setPagination({
                    ...pagination,
                    total: response.data?.page?.totalElements,
                });
            } catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoadingPage(false));
            }
        },
        [currentCompany, month, statusFlag, year, visible]
    );

    const getPayrollPerMonth = useCallback(
        async ({ changeYear, month } = {}) => {
            try {

                dispatch(setIsLoading(true));
                const values = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    year: changeYear || year,
                    statusFlag: statusFlag,
                    month: month,
                    page: pagination?.page || 0,
                    size: pagination?.size || 1000
                };
                const response = await services.getPayrollPeriodListPage(values);
                dispatch(setPayrollPerMonth(response?.data?.page?.content || []));
            } catch (error) {
                alert({ type: "error", resultObject: error });
            }
            finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, year]
    )


    const getPayrollPeriodDetails = useCallback(async (params) => {
        try {
            dispatch(setIsLoading(true));
            console.log("selectedPayrollPeriodId", params, selectedPayrollPeriodId);

            const response = await services.getPayrollPeriodDetails({
                ...params,
                companyId: currentCompany,
                employeeId: currentEmployee,
                actionId: currentEmployee,
            })
            dispatch(setPayrollPeriodCalculateDetails(response?.data?.content))
            setPagination2({ size: 10, ...pagination2, current: response?.data?.pageNo + 1, total: response.data?.totalItems });
        } catch (error) {
            alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, currentEmployee, pagination2, selectedPayrollPeriodId])

    function toParams(params = {}) {
        const { pagination = {}, sortBy = [] } = params;
        const modifiedParams = {
            pagination: {
                page: pagination?.page ?? 0,
                size: pagination?.pageSize ?? 10,
            },
            sortBy: sortBy
                .filter((s) => s?.order !== undefined)
                .map((s) => ({
                    direction: s?.order === "descend" ? "desc" : "asc",
                    property: s?.field,
                })),
        };
        return modifiedParams;
    }

    const handleOnChange = useCallback(
        (page, pageSize) => {
            setPagination({ ...pagination, page, size: pageSize });
            const modifiedParams = toParams({
                changeYear: year,
                pagination: {
                    page: page - 1,
                    pageSize: pageSize,
                },
            });
            getPayrollPeriodListPage({ ...modifiedParams });
        },
        [getPayrollPeriodListPage, year, pagination]
    );

    const onViewPayrollPeriodCalculateDetails = useCallback(async (id) => {
        setPagination()
        setIsModalDetailsOpen(true)
        setSelectedPayrollPeriodId(id)
        await getPayrollPeriodDetails({ page: 0, size: 10, txnPayrollPeriodId: id });
    }, [getPayrollPeriodDetails])

    const onCancelViewPayrollPeriodCalculateDetails = useCallback(() => {
        setIsModalDetailsOpen(false)
    }, [])

    const onPayrollPeriodCalculateDetailsPageChange = useCallback(
        (tablePagination, tableFilters, tableSorter, tableExtra) => {
            console.log('tablePagination', tablePagination);

            const modifiedSorter = Array.isArray(tableSorter)
                ? [...tableSorter]
                : [tableSorter];
            console.log("selectedPayrollPeriodId", selectedPayrollPeriodId);

            getPayrollPeriodDetails({
                page: tablePagination?.current - 1,
                size: tablePagination?.pageSize,
                pageSize: tablePagination?.pageSize,
                current: tablePagination.current - 1,
                txnPayrollPeriodId: selectedPayrollPeriodId,
            });
        },
        [getPayrollPeriodDetails, selectedPayrollPeriodId]
    );

    const getPayrollPeriodCalculateDetailsModal = useCallback(() => {
        return <PayrollPeriodCalculateDetailsModal
            isModalOpen={isModalDetailsOpen}
            isLoading={isLoading}
            onCancel={onCancelViewPayrollPeriodCalculateDetails}
            dataSource={payrollPeriodCalculateDetails}
            onChange={onPayrollPeriodCalculateDetailsPageChange}
            pagination={pagination2}
        />
    }, [payrollPeriodCalculateDetails, isModalDetailsOpen, isLoading, visible, payrollPeriodCalculateDetails, pagination2, onPayrollPeriodCalculateDetailsPageChange])

    const createPayrollSpecialPeriod = useCallback(
        async ({ changeYear = null, index, income, deduction, paymentDate }) => {
            try {
                const payrollSpecialPeriod = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    actionId: currentEmployee,
                    year: changeYear || year,
                    index: index,
                    paymentDate: paymentDate ? paymentDate.format("YYYY-MM-DD") : null,
                    income: income,
                    deduction: deduction
                };
                await services.createPayrollSpecialPeriod(payrollSpecialPeriod);
                dispatch(setIsLoading(true));
                onCancel();
                getPayrollPeriodList({ year: year });
                alert({ message: "Success" });
            }
            catch (error) {
                alert({ type: "error", resultObject: error });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee, onCancel, year]
    )

    const onCreateSpecial = useCallback(
        (values) => {
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: (
                    <>
                        <p>
                            {t("dialog.confirmation.create").replace("{entity}", t("payment_period.label.payment_period"))}
                        </p>
                    </>
                ),
                onOk() {
                    createPayrollSpecialPeriod(values);
                },
                okText: t("common.confirm").toUpperCase(),
                cancelText: t("common.cancel").toUpperCase(),
            });
        }, [createPayrollSpecialPeriod, t]
    )

    const createSpecialPeriod = useCallback(
        async (values = {}, cb = () => { }) => {
            try {
                console.log("values", values);
                // let period = periodOptions.find(o => o.id == values.periodId);
                // console.log("period", period, periodOptions);

                let json = {
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    employeeId: currentEmployee,
                    actionId: currentEmployee,
                    // employmentType: values?.employmentType,
                    paymentPeriodType: "0",
                    // year: values?.year?.format("YYYY"),
                    // month: values?.month?.format("MM"),
                    paymentDate: values?.paymentDate?.format("YYYY-MM-DD"),
                    index: "0",
                    allowPayBeforeHoliday: "N",
                    offCyclePayroll: "N",
                    periodId: values?.periodId
                    // startDate: values?.periodRange[0]?.format("YYYY-MM-DD"),
                    // endDate: values?.periodRange[1]?.format("YYYY-MM-DD")
                };

                let res = await services.createPayrollPeriod(json);
                cb?.()
                dispatch(setIsLoading(true));
                alert({ type: "success" });
            } catch (error) {
                alert({ type: "error", resultObject: error, noti: true });
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [currentCompany, currentEmployee, dispatch]
    );

    const onCreateSpecialSubmit = useCallback(
        (values, cb) => {
            Modal.confirm({
                title: t("dialog.confirmation.header"),
                content: (
                    <>
                        <p>
                            {t("dialog.confirmation.create").replace("{entity}", t("payment_period.label.special_payment_period"))}

                        </p>
                    </>
                ),
                onOk() {
                    function finish() {
                        setIsSpecialPeriodModalOpen(false);
                        getPayrollPeriodListPage({ changeYear: year, pagination });
                        cb?.()
                        dispatch(setPeriodOptions([]))
                    }
                    createSpecialPeriod(values, finish);

                },
                okText: t("common.confirm").toUpperCase(),
                cancelText: t("common.cancel").toUpperCase(),
            });
        },
        [t, createSpecialPeriod]
    );

    useEffect(() => {
        if (currentCompany) {
            getPayrollPeriodListPage({ changeYear: year, pagination });
            getPayrollPeriodList({ changeYear: year });
        }
    }, [currentCompany, statusFlag, month, year, visible]);

    useEffect(() => {
        if (currentCompany) {
            getSPecialPeriodDropdown({ changeYear: year });
        }
    }, [currentCompany])

    useEffect(() => {
        if (currentCompany) {
            getIncomeForSpecialPeriod();
        }
    }, [currentCompany])

    useEffect(() => {
        if (currentCompany) {
            getDeductionForSpecialPeriod();
        }
    }, [currentCompany])

    useEffect(() => {
        if (currentCompany) {
            getEmploymentType();
        }
    }, [currentCompany, getEmploymentType]);

    return {
        isModalOpenPerMonth,
        setModalOpenPerMonth,
        isModalOpen,
        payrollPeriodList,
        payrollPeriodListPage,
        isLoading,
        incomeForSpecialPeriod: modifiedIncomeForSpecialPeriod,
        deductionForSpecialPeriod: modifiedDeductionForSpecialPeriod,
        setModalOpen,
        onCancelPerMonth,
        getPayrollPeriodList,
        getPayrollPerMonth,
        payrollPerMonth,
        createPaymentByEmployeeIds,
        getPayrollPeriodListPage: handleOnChange,
        employmentTypeDropdown,
        getSPecialPeriodDropdown,
        specialPeriodDropdown,
        createPayrollSpecialPeriod,
        onCreateSpecial,
        onCancel,
        handleOk,
        onPayrollClick,
        getPayrollPeriod,
        handleVisible,
        visible,
        setVisible,
        pagination,
        setYear,
        setMonth,
        setStatusFlag,
        getPayrollPeriodDetails,
        onViewPayrollPeriodCalculateDetails,
        getPayrollPeriodCalculateDetailsModal,
        isSpecialPeriodModalOpen,
        setIsSpecialPeriodModalOpen,
        onCreateSpecialSubmit,
        updatePeriodOptions
    }
}

export default usePayrollPeriod;